import React from 'react';
import { ActivityIndicator, Pressable, PressableProps, Text, View } from 'react-native';

import { ButtonProps, SIZES } from '.';

import { getIconByName } from 'components/Icons';

type GhostButtonProps = Omit<ButtonProps, 'gradientVariant' | 'variant' | 'backgroundColor'>;

const GhostButton = React.forwardRef<PressableProps, GhostButtonProps>(
  (
    {
      children,
      iconStyle,
      iconType,
      style,
      isFullWidth = false,
      isLoading = false,
      size = 'md',
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;

    return (
      <Pressable
        ref={ref}
        style={[
          {
            backgroundColor: 'transparent',
            width: isFullWidth ? '100%' : undefined,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingHorizontal: 20,
            borderRadius: rounded ? 50 : 4,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#ccc',
          },
          style,
        ]}
        {...rest}>
        {Icon && (
          <View style={{ marginRight: 5 }}>
            <Icon {...iconStyle} />
          </View>
        )}
        {children && (
          <Text
            style={[
              {
                fontFamily: 'system-ui',
                fontSize: SIZES[size],
                fontWeight: 600,
                color: 'white',
                textTransform,
                marginTop: -1,
                marginBottom: -1,
              },
              textStyle,
            ]}>
            {children}
          </Text>
        )}
        {isLoading && <ActivityIndicator color="white" size="small" style={{ marginLeft: 4 }} />}
      </Pressable>
    );
  }
);

export default GhostButton;
